export const questionsCSS = {
  English: [
    {
      question: "Which CSS selector targets all elements on a page?",
      answers: [
        { answer: "body {}", correct: false, id: 1 },
        { answer: "* {}", correct: true, id: 2 },
        { answer: "all {}", correct: false, id: 3 },
        { answer: "page {}", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which CSS property defines text color?",
      answers: [
        { answer: "text-color", correct: false, id: 1 },
        { answer: "color", correct: true, id: 2 },
        { answer: "font-color", correct: false, id: 3 },
        { answer: "text-style", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which CSS property is used to set spacing around an element?",
      answers: [
        { answer: "padding", correct: true, id: 1 },
        { answer: "margin", correct: false, id: 2 },
        { answer: "border", correct: false, id: 3 },
        { answer: "spacing", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which measurement unit is not relative?",
      answers: [
        { answer: "em", correct: false, id: 1 },
        { answer: "px", correct: true, id: 2 },
        { answer: "%", correct: false, id: 3 },
        { answer: "rem", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which tag is used to insert CSS into an HTML document?",
      answers: [
        { answer: "<css>", correct: false, id: 1 },
        { answer: "<script>", correct: false, id: 2 },
        { answer: "<style>", correct: true, id: 3 },
        { answer: "<link>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which pseudoclass indicates an active link?",
      answers: [
        { answer: ":hover", correct: false, id: 1 },
        { answer: ":active", correct: true, id: 2 },
        { answer: ":visited", correct: false, id: 3 },
        { answer: ":link", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "What is the default color of text?",
      answers: [
        { answer: "white", correct: false, id: 1 },
        { answer: "black", correct: true, id: 2 },
        { answer: "red", correct: false, id: 3 },
        { answer: "blue", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "What is `!important` used for?",
      answers: [
        { answer: "Animation", correct: false, id: 1 },
        { answer: "Priority", correct: true, id: 2 },
        { answer: "Marking", correct: false, id: 3 },
        { answer: "Comment", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which pseudoclass is for hover?",
      answers: [
        { answer: ":focus", correct: false, id: 1 },
        { answer: ":hover", correct: true, id: 2 },
        { answer: ":active", correct: false, id: 3 },
        { answer: ":visited", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which sign is used for commenting in CSS?",
      answers: [
        { answer: "// ... //", correct: false, id: 1 },
        { answer: "/* ... */", correct: true, id: 2 },
        { answer: "<!-- ... -->", correct: false, id: 3 },
        { answer: "-- ... --", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Identify which of the listed elements are only block-level?",
      answers: [
        { answer: "<span>, <div>, <p>, <a>, <img>", correct: false, id: 1 },
        { answer: "<div>, <p>, <ul>, <li>, <h1>", correct: true, id: 2 },
        { answer: "<a>, <p>, <h2>, <ol>, <div>", correct: false, id: 3 },
        { answer: "<ul>, <p>, <div>, <img>, <h3>", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
  Ukrainian: [
    {
      question: "Який селектор в CSS вказує на всі елементи на сторінці?",
      answers: [
        { answer: "body {}", correct: false, id: 1 },
        { answer: "* {}", correct: true, id: 2 },
        { answer: "all {}", correct: false, id: 3 },
        { answer: "page {}", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який властивість CSS визначає колір тексту?",
      answers: [
        { answer: "text-color", correct: false, id: 1 },
        { answer: "color", correct: true, id: 2 },
        { answer: "font-color", correct: false, id: 3 },
        { answer: "text-style", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Яка властивість CSS використовується для встановлення відступу навколо елемента?",
      answers: [
        { answer: "padding", correct: true, id: 1 },
        { answer: "margin", correct: false, id: 2 },
        { answer: "border", correct: false, id: 3 },
        { answer: "spacing", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка одиниця вимірювання не відносна?",
      answers: [
        { answer: "em", correct: false, id: 1 },
        { answer: "px", correct: true, id: 2 },
        { answer: "%", correct: false, id: 3 },
        { answer: "rem", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який тег використовується для вставки CSS в HTML документі?",
      answers: [
        { answer: "<css>", correct: false, id: 1 },
        { answer: "<script>", correct: false, id: 2 },
        { answer: "<style>", correct: true, id: 3 },
        { answer: "<link>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який псевдоклас вказує на активне посилання?",
      answers: [
        { answer: ":hover", correct: false, id: 1 },
        { answer: ":active", correct: true, id: 2 },
        { answer: ":visited", correct: false, id: 3 },
        { answer: ":link", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який колір за замовчуванням у тексту?",
      answers: [
        { answer: "white", correct: false, id: 1 },
        { answer: "black", correct: true, id: 2 },
        { answer: "red", correct: false, id: 3 },
        { answer: "blue", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Для чого `!important`?",
      answers: [
        { answer: "Анімація", correct: false, id: 1 },
        { answer: "Приоритет", correct: true, id: 2 },
        { answer: "Відзначення", correct: false, id: 3 },
        { answer: "Коментар", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який псевдоклас для наведення?",
      answers: [
        { answer: ":focus", correct: false, id: 1 },
        { answer: ":hover", correct: true, id: 2 },
        { answer: ":active", correct: false, id: 3 },
        { answer: ":visited", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який знак для коментаря в CSS?",
      answers: [
        { answer: "// ... //", correct: false, id: 1 },
        { answer: "/* ... */", correct: true, id: 2 },
        { answer: "<!-- ... -->", correct: false, id: 3 },
        { answer: "-- ... --", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Вкажіть які з перечислених елементів є лише блочними?",
      answers: [
        { answer: "<span>, <div>, <p>, <a>, <img>", correct: false, id: 1 },
        { answer: "<div>, <p>, <ul>, <li>, <h1>", correct: true, id: 2 },
        { answer: "<a>, <p>, <h2>, <ol>, <div>", correct: false, id: 3 },
        { answer: "<ul>, <p>, <div>, <img>, <h3>", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
  Polish: [
    {
      question:
        "Który selektor CSS kieruje do wszystkich elementów na stronie?",
      answers: [
        { answer: "body {}", correct: false, id: 1 },
        { answer: "* {}", correct: true, id: 2 },
        { answer: "all {}", correct: false, id: 3 },
        { answer: "page {}", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która właściwość CSS definiuje kolor tekstu?",
      answers: [
        { answer: "text-color", correct: false, id: 1 },
        { answer: "color", correct: true, id: 2 },
        { answer: "font-color", correct: false, id: 3 },
        { answer: "text-style", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Która właściwość CSS jest używana do ustawienia odstępów wokół elementu?",
      answers: [
        { answer: "padding", correct: true, id: 1 },
        { answer: "margin", correct: false, id: 2 },
        { answer: "border", correct: false, id: 3 },
        { answer: "spacing", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która jednostka pomiarowa nie jest względna?",
      answers: [
        { answer: "em", correct: false, id: 1 },
        { answer: "px", correct: true, id: 2 },
        { answer: "%", correct: false, id: 3 },
        { answer: "rem", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który tag jest używany do wstawiania CSS do dokumentu HTML?",
      answers: [
        { answer: "<css>", correct: false, id: 1 },
        { answer: "<script>", correct: false, id: 2 },
        { answer: "<style>", correct: true, id: 3 },
        { answer: "<link>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który pseudoklasa wskazuje aktywny link?",
      answers: [
        { answer: ":hover", correct: false, id: 1 },
        { answer: ":active", correct: true, id: 2 },
        { answer: ":visited", correct: false, id: 3 },
        { answer: ":link", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jaki jest domyślny kolor tekstu?",
      answers: [
        { answer: "white", correct: false, id: 1 },
        { answer: "black", correct: true, id: 2 },
        { answer: "red", correct: false, id: 3 },
        { answer: "blue", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Do czego służy `!important`?",
      answers: [
        { answer: "Animacja", correct: false, id: 1 },
        { answer: "Priorytet", correct: true, id: 2 },
        { answer: "Oznaczenie", correct: false, id: 3 },
        { answer: "Komentarz", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która pseudoklasa jest dla wskaźnika?",
      answers: [
        { answer: ":focus", correct: false, id: 1 },
        { answer: ":hover", correct: true, id: 2 },
        { answer: ":active", correct: false, id: 3 },
        { answer: ":visited", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który znak jest używany do komentowania w CSS?",
      answers: [
        { answer: "// ... //", correct: false, id: 1 },
        { answer: "/* ... */", correct: true, id: 2 },
        { answer: "<!-- ... -->", correct: false, id: 3 },
        { answer: "-- ... --", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wskaż, które z wymienionych elementów są tylko blokowe?",
      answers: [
        { answer: "<span>, <div>, <p>, <a>, <img>", correct: false, id: 1 },
        { answer: "<div>, <p>, <ul>, <li>, <h1>", correct: true, id: 2 },
        { answer: "<a>, <p>, <h2>, <ol>, <div>", correct: false, id: 3 },
        { answer: "<ul>, <p>, <div>, <img>, <h3>", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
  German: [
    {
      question:
        "Welcher CSS-Selektor richtet sich nach allen Elementen auf einer Seite?",
      answers: [
        { answer: "body {}", correct: false, id: 1 },
        { answer: "* {}", correct: true, id: 2 },
        { answer: "all {}", correct: false, id: 3 },
        { answer: "page {}", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche CSS-Eigenschaft definiert die Textfarbe?",
      answers: [
        { answer: "text-color", correct: false, id: 1 },
        { answer: "color", correct: true, id: 2 },
        { answer: "font-color", correct: false, id: 3 },
        { answer: "text-style", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Welche CSS-Eigenschaft wird verwendet, um den Abstand um ein Element festzulegen?",
      answers: [
        { answer: "padding", correct: true, id: 1 },
        { answer: "margin", correct: false, id: 2 },
        { answer: "border", correct: false, id: 3 },
        { answer: "spacing", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Maßeinheit ist nicht relativ?",
      answers: [
        { answer: "em", correct: false, id: 1 },
        { answer: "px", correct: true, id: 2 },
        { answer: "%", correct: false, id: 3 },
        { answer: "rem", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Mit welchem Tag wird CSS in ein HTML-Dokument eingefügt?",
      answers: [
        { answer: "<css>", correct: false, id: 1 },
        { answer: "<script>", correct: false, id: 2 },
        { answer: "<style>", correct: true, id: 3 },
        { answer: "<link>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welcher Pseudoklasse zeigt einen aktiven Link an?",
      answers: [
        { answer: ":hover", correct: false, id: 1 },
        { answer: ":active", correct: true, id: 2 },
        { answer: ":visited", correct: false, id: 3 },
        { answer: ":link", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche ist die Standardfarbe von Text?",
      answers: [
        { answer: "weiß", correct: false, id: 1 },
        { answer: "schwarz", correct: true, id: 2 },
        { answer: "rot", correct: false, id: 3 },
        { answer: "blau", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wofür wird `!important` verwendet?",
      answers: [
        { answer: "Animation", correct: false, id: 1 },
        { answer: "Priorität", correct: true, id: 2 },
        { answer: "Markierung", correct: false, id: 3 },
        { answer: "Kommentar", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Pseudoklasse wird für Hover verwendet?",
      answers: [
        { answer: ":focus", correct: false, id: 1 },
        { answer: ":hover", correct: true, id: 2 },
        { answer: ":active", correct: false, id: 3 },
        { answer: ":visited", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welches Zeichen wird zum Kommentieren in CSS verwendet?",
      answers: [
        { answer: "// ... //", correct: false, id: 1 },
        { answer: "/* ... */", correct: true, id: 2 },
        { answer: "<!-- ... -->", correct: false, id: 3 },
        { answer: "-- ... --", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Identifizieren Sie, welche der aufgelisteten Elemente nur Blockebene sind?",
      answers: [
        { answer: "<span>, <div>, <p>, <a>, <img>", correct: false, id: 1 },
        { answer: "<div>, <p>, <ul>, <li>, <h1>", correct: true, id: 2 },
        { answer: "<a>, <p>, <h2>, <ol>, <div>", correct: false, id: 3 },
        { answer: "<ul>, <p>, <div>, <img>, <h3>", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
};
